import React from 'react'
import { AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import HomeIcon from '@material-ui/icons/Home'
import { makeStyles } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'

const useStyles = makeStyles(theme => ({
  root: {
    // flexGrow: 1,
    // textAlign: 'center',
    // alignItems: 'center',
  },
  // menuButton: {
  //   marginRight: theme.spacing(2),
  // },
  title: {
    // flexGrow: 1,
  },
  grid: {
    justifyItems: 'stretch',
    // display: 'inline',
    textAlign: 'center',
  },
  gridImagen: { alignSelf: 'center' },
  gridTitulo: { alignSelf: 'center' },
  imagen: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    objectFit: 'contain',
  },
}))

export const Menu = () => {
  const classes = useStyles()
  return (
    <AppBar position="sticky">
      <Toolbar className={classes.root}>
        <Grid container spacing={2} className={classes.grid}>
          <Grid item xs={4} sm={4} className={classes.gridImagen}>
            <Link href="http://accionexplorer.com/" color="inherit">
              <img alt="AE" className={classes.imagen} src={`/imagenes/logo.png`} />
            </Link>{' '}
          </Grid>
          {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
          <Link href="http://accionexplorer.com/" color="inherit">
            <HomeIcon />
          </Link>
        </IconButton> */}{' '}
          <Grid item xs={4} sm={4} className={classes.gridTitulo}>
            <Typography variant="h6" className={classes.title}>
              Recursos
            </Typography>
          </Grid>
          <Grid item xs={4} sm={4} className={classes.gridImagen}></Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}
